import { useEffect, useState } from "react";
import { Branch, IBranch } from "../components/models/branch/Branch";
import { getBranchActivitySummary, getBranchById, getBranches } from "../api/requests";
import { ISelectDropdownItem } from "../components/form-control/SelectDropdown";
import { IActivitySummary } from "../resources/interfaces";
import { ACTIVITY_SUMMARY_INIT_DATA } from "../views/dashboard/AgentDashboard";

function useBranches() {
    const [loading, setLoading] = useState<boolean>(true);
    const [branches, setBranches] = useState<Branch[]>([]);
    const [branch, setBranch] = useState<Branch>();

    const BRANCHES_LIST_FOR_FORM = branches.map((branch: Branch): ISelectDropdownItem => (
        {
            id: branch.id,
            name: `${branch.name}`,
            value: branch.id
        }
    ))

    const [activitySummary, setActivitySummary] = useState<IActivitySummary>(ACTIVITY_SUMMARY_INIT_DATA)

    const fetchBranches = (companyId = "") => {
        getBranches(companyId)
            .then((response: any) => {
                const _branches = response?.map((IBranch: IBranch) => new Branch(IBranch));

                setBranches(_branches);
            }).catch((error: any) => {
                console.log("request error", error);
            }).finally(() => setLoading(false))
    }

    const fetchBranchById = (id: string) => {
        getBranchById(id)
            .then((response: any) => {
                setBranch(new Branch(response));
            }).catch((error: any) => {
                console.log("request error", error);
            }).finally(() => {
                setLoading(false);
            })
    }

    const fetchActivitySummary = (id: string) => {
        getBranchActivitySummary(id)
            .then((response: any) => {
                setActivitySummary(response);
            }).catch((error: any) => {
                console.log("request error", error);
            }).finally(() => {
                setLoading(false);
            })
    }

    return {
        branches,
        setLoading,
        BRANCHES_LIST_FOR_FORM,
        fetchBranches,
        loading,
        setBranches,
        fetchBranchById,
        branch,
        fetchActivitySummary,
        activitySummary, 
        setBranch
    };

}

export default useBranches;